import React from 'react';
import Action from '../components/Action/Action';

const ActionPage = () => {
  return <div><Action /></div>; 
};

export default ActionPage;
